module.exports = __webpack_public_path__ + "static/media/Big_BallR.92ddaf81.png";